import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { publicApi } from "@/lib/api";
import { CarCard } from "@/components/site/CarCard";

export function AlternativeCars({ carId, dates }) {
  const [cars, setCars] = useState(null);
  useEffect(() => {
    if (!dates?.pickup || !dates?.ret) return;
    const t = setTimeout(() => {
      publicApi.get(`/cars/${carId}/alternatives`, { params: { pickup_at: dates.pickup, return_at: dates.ret } })
        .then((r) => setCars(r.data)).catch(() => setCars([]));
    }, 300);
    return () => clearTimeout(t);
  }, [carId, dates?.pickup, dates?.ret]);
  if (!cars || cars.length === 0 || dates.error) return null;
  const search = `?pickup=${encodeURIComponent(dates.pickup)}&return=${encodeURIComponent(dates.ret)}${dates.driver ? "&driver=1" : ""}`;
  return (
    <section className="mt-14" data-testid="alternative-cars">
      <h2 className="flex items-center gap-2 font-display text-2xl font-extrabold tracking-tight text-hc-ink">
        <Sparkles className="h-5 w-5 text-hc-gold" />
        {dates.unavailable ? "This car is booked for your dates — these are free" : "Other cars available for your dates"}
      </h2>
      <p className="mt-1 text-sm text-hc-slate">Similar cars you can book for the same pickup and return time.</p>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {cars.map((c, i) => <CarCard key={c.id} car={c} index={i} search={search} />)}
      </div>
    </section>
  );
}
